export default {
  schoolId: 565,
  abbr: "ynau",
};
